<template>
  <border-div    
    v-loading="loading"
    :width="420"
    :height="556"    
    element-loading-background="transparent"
  >
    <h3>无形资产统计</h3>
    <el-table
      v-if="!loading"
      :header-cell-style="rowClass"
      :data="tableData"
      :height="504"
      style="width: 100%;"
    >
      <el-table-column
        prop="street"
        width="80"
        label="街道"
      />
      <el-table-column
        prop="patNo"
        width="60"
        label="专利"
      />
      <el-table-column
        prop="trademark"
        width="60"
        label="商标"
      />
      <el-table-column
        prop="standard"
        width="60"
        label="标准"
      />
      <el-table-column
        prop="regard"
        width="80"
        label="认证认可"
      />
      <el-table-column
        prop="total"
        width="80"
        label="合计"
      />
    </el-table>
    <template slot="empty" />
  </border-div>
</template>
<script>
import BorderDiv from './BorderDiv'
export default {
  components:{
    BorderDiv
  },
  props:{
    tableData:{
      type:Array,
      default:()=>null
    }
  },
  data(){
    return {
      loading:true,
      rowClass:{
        backgroundColor:'#2e335d',
        color:'#fff',
        fontSize:12,
        fontWeight:'bold',
        height:'43px'
      }
    }
  },
  watch:{
    tableData:{
      handler(val){
        if(val && val.length > 0){
        this.loading = false
      }
      },
      deep:true
    }
  }
}
</script>
<style lang="scss" scoped>
  h3{
    font-size: 14px;
    color: #ABBEF1;
    margin:20px 30px 12px 30px;
    text-align: left;
  }
  
  
</style>